import React from 'react';
import { connect } from 'react-redux';

import { answerQuestion } from '../../../../../_actions/questionnaire.actions';

const LongText = ({ question, dispatch }) => {
  return <>
    <h6 className="card-title">{question.text || 'Enter your question.'}</h6>

    <textarea
      onChange={(e) => { dispatch(answerQuestion(question, e.target.value)) }}
      className="form-control" rows="3"></textarea>
  </>;
}

export default connect()(LongText);